import styles from "./style.module.scss";
import { useQuery } from "@tanstack/react-query";
import OneElement from "./oneElement";
// import { useState } from "react";
import { GQLOffers, GQLForms, GQLCategories } from "@gql/types/gql";
import OfferLinks from "../offerLinks";
// import XIcon from "./icons/xIcon";
import {
    PLACE_HOLDER_IMAGE_PATH,
    socialMediaShareLinks,
} from "@lib/sharedUtils";
// import Portal from "src/portals/Portal";
import {
    Languages,
    TranslationsObject,
    FormActionTypes,
} from "@genericTypes/sharedTypes";
import { translate } from "@helpers/translationObjectFormatter";
import VendorsSideBySideComparison from "@components/vendorsSideBySideComparison";
// import Share from "../share/Share";
import Rating from "@components/rating";
import { getUrl } from "@helpers/switchLanguage";
import { useDispatch } from "../form/formReducer/FormReducer";

export interface VendorsToCompare {
    slug: string;
    label: string;
    logo: string;
    category: string;
}

export default function SideWidget({
    myList,
    vendor,
    VendorsToCompare,
    showSideBySideComparison = false,
    contentToBeSharedUrl,
    category,
}: {
    myList: {
        title: string;
        slug: string;
        content: { title: string | null; link: string }[];
    }[];
    vendor?: GQLOffers;
    VendorsToCompare?: VendorsToCompare[];
    showSideBySideComparison?: boolean;
    contentToBeSharedUrl: string;
    category: GQLCategories;
}) {
    const dispatch = useDispatch();

    const formData = useQuery<GQLForms>({
        queryKey: ["activeForm", category?.slug],
    }).data?.domainForm;

    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    // const [modalVisibility, setModalVisibility] = useState(false);

    const discountValue = vendor?.attributes?.find(
        (attr) => attr?.baseAttribute?.name === "discountValue",
    )?.value;
    return (
        <>
            {formData && (
                <div
                    className={`${styles["visibilityOnMobile"]} font-bold py-3 px-24 rounded-lg bg-[#0E2450] text-white  mt-3 sticky bottom-2 z-[51]  `}
                    onClick={() => {
                        dispatch({
                            type: FormActionTypes.SET_STEP_TO_SHOW_BACK_BTN,
                            payload: 1,
                        });
                        dispatch({
                            type: FormActionTypes.SET_MODAL_VISIBILITY,
                            payload: true,
                        });
                    }}
                >
                    {translate(translations, "several_general-get-a-quote")}
                </div>
            )}

            <section className="lg:w-[27%] lg:sticky lg:top-7">
                {/* {modalVisibility && (
                    <Portal>
                        <div
                            className={`flex items-center justify-end ${styles["modalStyle"]} flex justify-end flex-col `}
                        >
                            <div
                                className={`${styles["widgetRadius"]}  bg-white   w-[87%] max-w-[500px] `}
                            >
                                <div
                                    className={`${styles["visibilityMobile"]}   `}
                                >
                                    <span
                                        className={`${styles["boxShadowStyle"]} block max-h-[500px] overflow-auto  rounded-lg px-7 py-6 cursor-pointer `}
                                    >
                                        <div className=" flex items-baseline justify-between mb-4">
                                            <p className="font-bold ">
                                                {translate(
                                                    translations,
                                                    "several_general_sideWidget_title",
                                                )}
                                            </p>
                                            <span
                                                onClick={() => {
                                                    setModalVisibility(false);
                                                }}
                                            >
                                                <XIcon />
                                            </span>
                                        </div>

                                        {myList?.map((el, index) => (
                                            <OneElement
                                                key={index}
                                                title={el.title}
                                                content={el.content}
                                                slug={el.slug}
                                                setModalVisibility={
                                                    setModalVisibility
                                                }
                                            />
                                        ))}
                                        {showSideBySideComparison &&
                                            VendorsToCompare &&
                                            VendorsToCompare?.length > 0 && (
                                                <>
                                                    <div className="  text-sm font-bold  text-black lg:text-[#58616d] border-t py-6">
                                                        {translate(
                                                            translations,
                                                            "several_vendor_sideBySideComparison",
                                                        )}
                                                        &nbsp;
                                                        <span className="font-extrabold italic ">
                                                            {vendor?.name ?? ""}
                                                        </span>
                                                    </div>
                                                    <VendorsSideBySideComparison
                                                        vendorsToCompare={
                                                            VendorsToCompare ??
                                                            []
                                                        }
                                                        vendor={
                                                            vendor as GQLOffers
                                                        }
                                                    />
                                                </>
                                            )}

                                        <h3
                                            className={`mt-4 text-sm font-bold`}
                                        >
                                            {translate(
                                                translations,
                                                "several_general_share",
                                            )}
                                        </h3>
                                        <div
                                            className={`flex  gap-2 mt-3 justify-center ${styles["iconStyles"]} `}
                                        >
                                            <Share
                                                contentToBeSharedUrl={
                                                    contentToBeSharedUrl
                                                }
                                            />
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Portal>
                )} */}
                <div
                    className={`  ${styles["mainContainer"]} rounded-lg  pt-5  ${styles["visibilityDesktop"]} customScroll`}
                >
                    {vendor && discountValue && (
                        <span className={styles["badge"]}>
                            {translate(
                                translations,
                                "several_general-DiscountWord",
                            )}{" "}
                            {`${discountValue}%`}
                        </span>
                    )}
                    <div className="px-5 ">
                        {vendor && (
                            <div
                                className={`lg:w-[222px] lg:h-[212px] w-[235px] h-[135px] flex flex-col items-center  justify-evenly  ${styles["borderStyle"]}  overflow-auto`}
                            >
                                <span
                                    className={`relative block ${styles["topBuyerImage"]}  `}
                                >
                                    {vendor.logo?.fullPath ? (
                                        <img
                                            src={vendor.logo.fullPath}
                                            alt={vendor.logo?.alt || "logo"}
                                            width={150}
                                            height={40}
                                        />
                                    ) : (
                                        <>
                                            <img
                                                src={PLACE_HOLDER_IMAGE_PATH}
                                                alt="logo"
                                                width={150}
                                                height={40}
                                            />
                                        </>
                                    )}
                                </span>
                                {vendor?.score && (
                                    <Rating value={vendor.score} />
                                )}
                                <div className=" w-[92%]">
                                    <OfferLinks
                                        vendor={vendor}
                                        categoryId={
                                            vendor?.categories?.[0]
                                                ?.id as number
                                        }
                                        vendorShow={true}
                                    />
                                </div>
                            </div>
                        )}

                        {myList?.map((el, index) => (
                            <OneElement
                                key={index}
                                title={el.title}
                                content={el.content}
                                slug={el.slug}
                                url={contentToBeSharedUrl}
                            />
                        ))}
                        {showSideBySideComparison && (
                            <>
                                <div className=" lg:text-lg text-sm font-bold lg:font-normal text-black lg:text-[#58616d] border-t py-6">
                                    {translate(
                                        translations,
                                        "several_vendor_sideBySideComparison",
                                    )}
                                    &nbsp;
                                    <span className="font-extrabold italic">
                                        {vendor?.name ?? ""}
                                    </span>
                                </div>
                                <VendorsSideBySideComparison
                                    vendorsToCompare={
                                        VendorsToCompare as VendorsToCompare[]
                                    }
                                    vendor={vendor as GQLOffers}
                                />
                            </>
                        )}
                    </div>

                    <div className={`  p-5 ${styles["backgroundStyle"]}`}>
                        <h3 className={` text-sm ${styles["shareColor"]} `}>
                            {translate(translations, "several_general_share")}
                        </h3>
                        <div className={` flex  gap-1 mt-1 `}>
                            {socialMediaShareLinks?.map((el, index) => (
                                <a
                                    key={index}
                                    className={`cursor-pointer ${styles["share-icon"]}`}
                                    onClick={() => {
                                        window.open(
                                            `${el.link}${getUrl(
                                                process.env
                                                    .NEXT_PUBLIC_DEFAULT_LANG as Languages,
                                                contentToBeSharedUrl,
                                            )}`,
                                            "",
                                            "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600",
                                        );
                                        return false;
                                    }}
                                >
                                    {el.icon}
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
